<template>
  <!-- 话题 -->
  <div class="topic-wrap" v-if="topicList.length">
    <div class="topic-head">
      <div class="topic-title">{{ $t('hotTopic') }}</div>
      <div class="topic-all">
        <router-link @click="entryAllTopic" :to="{
          name: 'topics'
        }">
          {{ $t('allTopic') }}
        </router-link>
      </div>
    </div>
    <swiper
      class="swiper-topic-container"
      :space-between="30"
      :direction="'vertical'"
      :scrollbar="{ draggable: false }"
      :modules="modulesTopic"
      :loop="true"
      :autoplay="{
        delay: 4000,
        disableOnInteraction: false,
      }"
    >
      <swiper-slide v-for="topic in topicList" :key="topic.id">
        <div class="topic-content" @click="linkToTopic(topic.id, topic)">
          <div class="topic-name">
            <svg-icon name="icon-topic"></svg-icon>
            {{ topic.name }}
          </div>
          <div class="topic-counts">
            <span>{{ $numFormat(topic.threadCount) }} {{ $t('thread') }}</span>
            <span class="dot"></span> 
            <span>{{ $numFormat(topic.viewCount) }} {{ $t('views') }}</span>
            <svg-icon class="icon-arrow" name="icon-arrow"></svg-icon>
          </div>
        </div>
      </swiper-slide>
      <div class="topic-right-icon">
        <svg-icon name="icon-topic-full"></svg-icon>
      </div>
    </swiper>
  </div>
  <BorderLine v-if="topicList.length"/>
</template>

<script setup>

// swiper： Navigation（导航标） Pagination（分页器） Autoplay（自动播放）
import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'

const route = useRoute()
const router = useRouter()

const modulesTopic = [Autoplay]
const { proxy } = getCurrentInstance()

const topicList = ref([])

function linkToTopic (topicId, topic) {
  proxy.$ga('click_topic_entry', {
    "screen_name": route.name,
    "topic": topic.name,
    "entry_position": 'Trending Topics'
  })
  router.push({
    name: 'topic',
    params: {
      id: topicId
    }
  })
}

// 获取推荐话题，默认取前5
async function getRecommendedTopic () {
  const { code, data, msg } = await proxy.$http.getRecommendedTopic({page: 1, limit: 5})
  if (code !== 200 || !data) return
  topicList.value = data.rows
}

function entryAllTopic () {
  proxy.$ga('view_all_topics', {
    "screen_name": route.name,
    "button_name": 'All Topics'
  })
}

onBeforeMount(async () => {
  await getRecommendedTopic()
})
</script>

<style lang="postcss" scoped>
.topic-wrap {
  box-shadow: inset 0px 0.33px 0px var(--line);
  padding: 16px 20px;
  .topic-head {
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .topic-title {
      font-size: 16px;
      line-height: 21px;
      font-family: 'orbit-M';
    }
    .topic-all a {
      color: var(--theme);
      font-size: 12px;
      line-height: 16px;
    }
  }
}
.swiper-topic-container {
  height: 68px;
  background: var(--background-listpressed);
  margin: 0;
  .topic-content {
    width: 95%;
    padding: 12.5px 12px 12px 12px;
    .topic-name {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      font-size: 14px;
      font-family: "orbit-M";
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: var(--text-primary);
      .svg-icon {
        width: 18px;
        height: 18px;
        margin-right: 2px;
      }
    }
    .topic-counts {
      color: var(--text-secondary);
      font-size: 14px;
      line-height: 23px;
      margin-top: 4px;
      display: flex;
      align-items: center;
      .dot {
        margin: 0 8px;
        width: 3px;
        height: 3px;
        background: var(--text-secondary);
        border-radius: 50%;
      }
      .icon-arrow {
        width: 16px;
        height: 19px;
      }
    }
  }
  .topic-right-icon {
    position:absolute;
    right: -16px;
    top: -16px;
    .svg-icon {
      width: 100px;
      height: 100px;
    }
  }
}
</style>